import * as React from 'react';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import SettingsIcon from '@material-ui/icons/Settings';
import { useMediaQuery, Theme } from '@material-ui/core';
import { useTranslate, MenuItemLink } from 'react-admin';

import grid from '../grid';
import { AppState } from '../types';
import SubMenu from './SubMenu';


interface Props {
    dense: boolean;
    logout: () => void;
    onMenuClick: () => void;
}

const Menu: FC<Props> = ({ onMenuClick, dense, logout }) => {
    // eslint-disable-next-line
    const [] = useState({
        menuUsers: false,
        menuIssues: false,
        menuGrid: false,
    });
    const translate = useTranslate();
    const isXSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('xs')
    );
    const open = useSelector((state: AppState) => state.admin.ui.sidebarOpen);
    useSelector((state: AppState) => state.theme); // force rerender on theme change
    const label = (text: string) => <span className="menu-label">{text}</span>;

    return (
        <div
            style={{
                marginTop: 12,
                paddingBottom: 12,
                overflowX: 'hidden',
                overflowY: 'visible',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                width: '380px',
            }}
            className="menu-container menu-shell"
        >
            <div className="menu-header">
                <div className="menu-title">Sprive Admin</div>
                <div className="menu-subtitle">Control Center</div>
            </div>
            {' '}
            {/* <DashboardMenuItem onClick={onMenuClick} sidebarIsOpen={open} /> */}

                {/* Main Menu Items */}
                <div className="menu-section">Core</div>
                <MenuItemLink
                    to={'/userDetail'}
                    primaryText={label(translate(`resources.userDetail.name`, {
                        smart_count: 2,
                    }))}
                    leftIcon={<grid.icon />}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                <MenuItemLink
                    to={'/giftCardTransactionDetailsPage'}
                    primaryText={label(translate(`resources.giftCardTransactionDetailsPage.name`, {
                        smart_count: 2,
                    }))}
                    leftIcon={<grid.icon />}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                <MenuItemLink
                    to={'/amlChecks'}
                    primaryText={label(translate(`resources.amlChecks.name`, {
                        smart_count: 2,
                    }))}
                    leftIcon={<grid.icon />}
                    sidebarIsOpen={open}
                    dense={dense}
                />
                <MenuItemLink
                    to={'/updateGiftCardBlackList'}
                    primaryText={label(translate(`resources.updateGiftCardBlackList.name`, {
                        smart_count: 2,
                    }))}
                    leftIcon={<grid.icon />}
                    sidebarIsOpen={open}
                    dense={dense}
                />

                {/* Sub-Menus */}
                <div className="menu-section">Operations</div>
                <SubMenu dense={dense} onMenuClick={onMenuClick} />

                {/* Manage Admin Users - moved to last */}
                <div className="menu-section">Admin</div>
                <MenuItemLink
                    to={'/manageUser'}
                    primaryText={label("Manage Admin Users")}
                    leftIcon={<grid.icon />}
                    sidebarIsOpen={open}
                    dense={dense}
                />
{/* 
              <MenuItemLink
                    to={`/admin/grid/users`}
                    primaryText={translate(`resources.users.name`, {
                        smart_count: 2,
                    })}
                    leftIcon={<users.icon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                />
            <MenuItemLink
                    to={`/issues`}
                    primaryText={translate(`resources.issues.name`, {
                        smart_count: 0,
                    })}
                    leftIcon={<issues.icon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                /> */}
            {isXSmall && (
                <MenuItemLink
                    to="/configuration"
                    primaryText={label(translate('pos.configuration'))}
                    leftIcon={<SettingsIcon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                    dense={dense}
                />
            )}
            {isXSmall && logout}
        </div>
    );
};

export default Menu;
